var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('obj-page-container',{staticStyle:{"padding":"0 1.25rem","width":"900px","margin":"3rem auto"},attrs:{"headline":_vm.$t('impressum')}},[_c('cbr-corporate-information')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de8952fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/ImpressumPage.vue
// module id = 221
// module chunks = 0